module.exports = __webpack_public_path__ + "media/images/admin2/Radio-47eff9bf4a481de1699631c73249683e.svg";